import * as React from 'react'

type UseFullScreenProps = {
	ref: React.RefObject<null | HTMLDivElement>
}

const useFullScreen = ({ ref }: UseFullScreenProps): [boolean, () => void] => {
	const [isFullScreen, setIsFullScreen] = React.useState(false)

	const enterFullScreen = () => {
		if (ref.current) {
			ref.current.requestFullscreen()
		}
	}

	const exitFullScreen = () => {
		if (document.fullscreenElement) {
			document.exitFullscreen()
		}
	}

	const toggleFullScreen = () => {
		isFullScreen ? exitFullScreen() : enterFullScreen()
	}

	React.useEffect(() => {
		const handleFullscreenChange = () => {
			setIsFullScreen(document.fullscreenElement !== null)
		}

		document.addEventListener('fullscreenchange', handleFullscreenChange)

		return () =>
			document.removeEventListener('fullscreenchange', handleFullscreenChange)
	}, [])

	return [isFullScreen, toggleFullScreen]
}

export { useFullScreen }
